import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

const ConfirmIcon = (props) => <FontAwesomeIcon icon={["fas", "check"]} {...props}/>

export default ConfirmIcon;

